<template>
  <div class="not-found-page-container hidden">
    Deze pagina kon niet worden gevonden
  </div>
</template>

<script>
export default {
    name: 'NotFound',
    mounted(){
      this.$store.commit('updateActivePage', 'NotFound')  

      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
                if(entry.isIntersecting){
                entry.target.classList.add('show')
              } 
          })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Niet gevonden - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Over ons website Milad");
      this.$store.commit('updateActivePage', 'NotFound')
    }
}
</script>

<style>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}
.not-found-page-container {
  /* background-color: lightblue; */
  margin-top: 87px;
  min-height: 613px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

@media(max-width: 991px) {
  .not-found-page-container {
  /* background-color: pink; */
  margin-top: 57px;
  min-height: 381px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
}
</style>